import { createUseStyles } from 'react-jss';

const styles = {
  proposalContent: {
    maxWidth: '118rem',
    margin: '0 auto',
    width: '90%',
    '@media (max-width: 1240px) ': {
      width: '95%',
    },
    '@media (max-width: 1150px) ': {
      width: '90%',
    },
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
